<template>
  <template v-if="isApplicationLoading">
    <Loading />
  </template>
  <template v-else>
    <div class="my-5">
      <SectionContainer class="landlord-description">
        <h2 class="text-xl">
          {{ getCurrentApplication.unit_address }}
        </h2>
        <h5 class="text-brand-black py-1">
          {{ getCurrentApplication.applicant.name }}
        </h5>
        <Line />

        <div class="flex flex-row justify-between py-2">
          <div class="flex items-center w-2/3">
            <h2 class="text-xl">Payment for Additional Reports</h2>
          </div>
          <div class="flex justify-end items-center w-1/3">
            <LockClosedIcon class="text-brand-blue w-5 h-5 md:w-8 md:h-8 mr-1" />
            <p class="text-brand-blue text-2xs md:text-xs">Secure</p>
          </div>
        </div>

        <div class="pb-5 md:pl-8">
          <p class="py-1">Reports requested:</p>
          <p
            class="font-semibold py-0.5"
            v-for="report in getCurrentApplication.reports.filter(
              (r) => r.status === 'sent_payment_request'
            )"
            :key="report.id"
          >
            {{ report.short_label }}
          </p>
        </div>
        <p class="py-2 font-light">
          You are now paying a non-refundable application fee for this rental application.
        </p>
        <p class="py-2 font-light">
          Note: It may take a few moments for your payment to process. Please do NOT press the back
          button or refresh this page.
        </p>

        <div class="py-3 md:w-2/3">
          <label class="block"> Credit card number </label>
          <CardInput class="py-2" ref="card" @validate="validateInput" />

          <div class="flex pt-2">
            <input
              id="card-box"
              type="checkbox"
              class="h-5 w-5 rounded-sm border-gray-300 text-brand-green focus:ring-brand-green"
              v-model="receipt"
            />
            <label for="card-box" class="ml-2 text-sm text-brand-dark-gray italic"
              >I want to receive a receipt for this payment</label
            >
          </div>
        </div>
        <div class="flex w-full flex-row justify-end py-3">
          <div class="flex flex-row w-full md:w-1/3">
            <div class="flex-1">
              <h5 class="text-xl">Total fee:</h5>
            </div>
            <div class="flex-1 text-right">
              <p class="text-xl font-semibold">${{ totalFee }}</p>
            </div>
          </div>
        </div>

        <div class="py-5 w-full md:w-1/2 mx-auto">
          <p v-if="errorMessage" class="text-brand-red mb-2 text-center">{{ errorMessage }}</p>
          <PrimaryButton
            @click="pay"
            :disabled="!isInputValid || isStripeLoading || isApplicationLoading"
            :is-loading="isStripeLoading || isApplicationLoading"
            >Submit Payment</PrimaryButton
          >
        </div>

        <p class="text-xs text-brand-mid-gray py-5">
          In clicking Submit Payment you agree to the full non-refundable application fee above.
          This non-refundable fee covers the processing of screening reports and any additional
          fees. This fee is not contingent on acceptance. This charge will appear on your credit
          card statement from RentApplication.net.
        </p>
      </SectionContainer>
    </div>
  </template>
</template>
<script>
import { mapGetters } from "vuex"
import { LockClosedIcon } from "@heroicons/vue/outline"

import { APPLICATION_BUY_REPORTS_BY_APPLICANT } from "@/store/types"

export default {
  components: {
    LockClosedIcon
  },
  computed: {
    ...mapGetters(["getCurrentApplication", "isApplicationLoading"]),
    totalFee() {
      if (!this.getCurrentApplication) {
        return 0
      }
      return this.getCurrentApplication.reports
        .filter((r) => r.status === "sent_payment_request")
        .reduce((total, r) => {
          return total + r.price
        }, 0)
        .toFixed(2)
    }
  },
  data() {
    return {
      receipt: true,
      isStripeLoading: false,
      isInputValid: false,
      errorMessage: ""
    }
  },
  methods: {
    validateInput() {
      this.isInputValid = true
    },
    async pay() {
      const card = this.$refs.card.card
      const stripe = this.$refs.card.stripe

      let result
      // TODO: Display error from stripe
      try {
        this.isStripeLoading = true
        result = await stripe.createToken(card)
        this.isStripeLoading = false
      } catch (err) {
        this.errorMessage = err.response.message
        return
      }

      try {
        await this.$store.dispatch(APPLICATION_BUY_REPORTS_BY_APPLICANT, {
          id: this.getCurrentApplication.id,
          token: result.token.id,
          receipt: this.receipt
        })

        this.$router.push({ name: "request_payment_complete" })
      } catch (err) {
        console.log(err)
        this.errorMessage = err.response.data.message
      }
    }
  }
}
</script>
